// extracted by mini-css-extract-plugin
module.exports = {"logoWall":"LogoWall_logoWall__yb0MX","logoWall__redesign":"LogoWall_logoWall__redesign__PftwF"};